<template>
    <pc-transition
        v-bind:transition="transition"
        v-on:after-enter="afterEnter">
        <template v-if="shown">
            <div
                v-bind:class="alertClass"
                class="py-2 alert">
                <div v-if="title">
                    <h4 class="alert-heading">
                        {{ title }}
                    </h4>
                    <hr />
                </div>
                <div class="d-flex justify-content-between">
                    <span
                        v-if="message"
                        v-bind:id="internalId"
                        data-test-role="message"
                        class="me-auto">
                        {{ message }}
                    </span>
                    <slot />
                    <button
                        v-if="dismissible"
                        class="btn-close align-self-start ms-2"
                        aria-label="Close"
                        type="button"
                        v-on:click="dismiss" />
                </div>
            </div>
        </template>
    </pc-transition>
</template>
<script>
    import { ALERT_SEVERITY } from "Util/alerts";

    export default {
        props: {
            // Whether or not the alert is shown.
            shown: { type: Boolean, required: true, default: false },

            // If > 0, alert will disappear after that number of ms
            duration: { type: Number, required: false, default: 0 },

            dismissible: { type: Boolean, required: false, default: false },
            severity: { type: String, required: false, default: ALERT_SEVERITY.info },
            message: { type: String, required: false, default: null },
            textId: { type: String, required: false, default: null },
            title: { type: String, required: false, default: null },
            transition: { type: String, required: false, default: "slide" }
        },
        emits: ["update:shown"],
        data() {
            return {
                internalId: this.textId || this.$idGenerator.getNextId("pcAlert")
            };
        },
        computed: {
            alertClass() {
                switch (this.severity) {
                    case ALERT_SEVERITY.success:
                        return "alert-success";
                    case ALERT_SEVERITY.warning:
                        return "alert-warning";
                    case ALERT_SEVERITY.error:
                        return "alert-danger";
                    case ALERT_SEVERITY.info:
                    default:
                        return "alert-info";
                }
            }
        },
        methods: {
            dismiss() {
                this.$emit("update:shown", false);
            },
            afterEnter() {
                if (!this.dismissible && this.duration > 0) {
                    setTimeout(() => {
                        this.$emit("update:shown", false);
                    }, this.duration);
                }
            }
        }
    };
</script>
